import { useEffect } from 'react';
import clippy from 'clippyts';

// The agent creates DOM outside React. Share one load across StrictMode,
// desktop interactions and sign-out/sign-in cycles.
let agentPromise = module.hot?.data?.agentPromise;
if (module.hot) module.hot.dispose((data) => { data.agentPromise = agentPromise; });
const loadAssistant = () => {
  if (!agentPromise) {
    agentPromise = new Promise((resolve, reject) => {
      clippy.load({ name: 'Rocky', successCb: resolve, failCb: reject });
    }).catch((error) => {
      agentPromise = undefined;
      throw error;
    });
  }
  return agentPromise;
};

const DesktopAssistant = () => {
  useEffect(() => {
    let cancelled = false;
    let assistant;
    loadAssistant().then((agent) => {
      if (cancelled) return;
      assistant = agent;
      agent.show(true);
      agent.moveTo(Math.max(0, window.innerWidth - 140), Math.max(0, window.innerHeight - 130), 0);
      agent.speak('Bem-vindo ao meu portfólio!');
    }).catch((error) => console.warn('Não foi possível carregar o assistente.', error));
    return () => {
      cancelled = true;
      if (assistant) assistant.hide(true);
    };
  }, []);
  return null;
};

export default DesktopAssistant;
